import draftOrder from '../data/draft-order';
import { getTeamLogo } from '../lib';

export const actionTypes = {
    setStep: 'STATUS_SET_STEP',
    startDraft: 'STATUS_START_DRAFT',
    pickPlayer: 'STATUS_PICK_PLAYER',

    restartDraft: 'STATUS_RESTART_DRAFT',
    setRoundFIlter: 'STATUS_SET_ROUND_FILTER',
}

// function shuffleArray(array) {
//     for (let i = array.length - 1; i > 0; i--) {
//         const j = Math.floor(Math.random() * (i + 1));
//         [array[i], array[j]] = [array[j], array[i]];
//     }
// }

export const setStep = (stepNumber) => ({ type: actionTypes.setStep, stepNumber });
// export const startDraft = (year, picksPerRound, totalRounds) => {
//     let draftResults = null;
//     draftResults = draftOrder[year];
//
//     const teamsPicking = draftResults.slice(0, picksPerRound * totalRounds);
//     const formattedTeams = teamsPicking.map((x) => ({code: x.team, logo: getTeamLogo(x.team.trim())}));
//
//     return { type: actionTypes.startDraft, draftOrder: formattedTeams };
// };

export const startDraft = (year, roundPickRanges, totalRounds) => {
    let draftResults = null;
    draftResults = draftOrder[year];

    // Calculate the number of picks for each round based on roundPickRanges
    const totalPicksPerRound = roundPickRanges
        .slice(0, totalRounds) // Consider only the specified number of rounds
        .map(({ start, end }) => end - start + 1);

    // Flatten the array of picks for each round
    const teamsPicking = draftResults.slice(0, totalPicksPerRound.reduce((acc, val) => acc + val, 0));
    const formattedTeams = teamsPicking.map((x) => ({ code: x.team, logo: getTeamLogo(x.team.trim()) }));

    return { type: actionTypes.startDraft, draftOrder: formattedTeams };
};

// export const pickPlayer = (currentPickNumber, totalRounds, picksPerRound, selectedPlayer) => {
//     const currentRound = Math.ceil(currentPickNumber / picksPerRound);
//     const draftFinished = Math.ceil((currentPickNumber + 1) / picksPerRound) > totalRounds;
//     const firstPickOfRound = currentPickNumber % picksPerRound === 0;
//     const nextRound = draftFinished ? currentRound : (firstPickOfRound ? currentRound + 1 : currentRound);
//     return { type: actionTypes.pickPlayer, nextRound, selectedPlayer, draftFinished };
// }

export const pickPlayer = (currentPickNumber, totalRounds, roundPickRanges, selectedPlayer) => {
    // Find the current round based on the current pick number
    const currentRound = roundPickRanges.findIndex(range => currentPickNumber >= range.start && currentPickNumber <= range.end) + 1;

    // Calculate the number of picks per round for the current round
    //const picksPerRound = roundPickRanges[currentRound - 1].end - roundPickRanges[currentRound - 1].start + 1;

    // Calculate the number of picks for the current round
    const totalPicksTillCurrentRound = roundPickRanges
        .slice(0, currentRound)
        .reduce((total, range) => total + (range.end - range.start + 1), 0);

    // Calculate the total number of picks for rounds up to totalRounds
    const totalPicksTillTotalRound = roundPickRanges
        .slice(0, totalRounds)
        .reduce((total, range) => total + (range.end - range.start + 1), 0);

    // Check if the draft is finished
    const draftFinished = (currentPickNumber + 1) > totalPicksTillTotalRound;

    // Check if it's the first pick of the current round
    const lastPickOfRound = currentPickNumber === roundPickRanges[currentRound - 1].end;

    // Calculate the next round
    const nextRound = draftFinished ? currentRound : (lastPickOfRound ? currentRound + 1 : currentRound);

    return { type: actionTypes.pickPlayer, nextRound, selectedPlayer, draftFinished };
}

//export const manualPick = (currentPickNumber, currentRound, totalRounds, picksPerRound, playerId)

export const restartDraft = () => ({ type: actionTypes.restartDraft });
export const setRoundFilter = (round) => ({ type: actionTypes.setRoundFilter, round });